export default __webpack_public_path__ + "static/brian-fitz-bitmoji-3bca8d5e1684739a9a43deddc4903dea.png";